import { Store } from 'vuex'

import Vue from 'vue'
import user from './modules/user'
import company from './modules/company'
import card from './modules/card'
import order from './modules/order'
import orderItems from './modules/order-items'
import orderReplacementCard from './modules/order-replacement-card'
import orderTerminateCard from './modules/order-terminate-card'
import tlsProduct from './modules/tls-product'
import rorProduct from './modules/ror-product'
import trip from './modules/trip'
import alert from './modules/alert'
import invoice from './modules/invoice'
import invoiceSpecifications from './modules/invoice-specifications'

export default function buildStore (vuexSession, vuexLogger) {
  const plugins = [vuexSession.plugin]
  if (vuexLogger) {
    plugins.push(vuexLogger)
  }

  const strictMode = Vue.prototype.$container.config.env === 'development'
  const modules = {
    user,
    company,
    card,
    order,
    orderItems,
    orderReplacementCard,
    orderTerminateCard,
    alert,
    tlsProduct,
    rorProduct,
    invoiceSpecifications,
    trip,
    invoice
  }

  return new Store({
    modules,
    mutations: {
      RESTORE_MUTATION: vuexSession.RESTORE_MUTATION,
      resetModuleState (state, moduleKey) {
        state[moduleKey] = { ...modules[moduleKey].initialState }
      }
    },
    strict: strictMode,
    plugins,
    actions: {
      async resetAllState ({ commit }) {
        Object.keys(modules).forEach(moduleKey => {
          if (modules[moduleKey].hasOwnProperty('initialState')) {
            commit('resetModuleState', moduleKey)
          }
        })
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/store/index.js